export default __webpack_public_path__ + "static/media/lm6090.d70b09fa.png";